import CMSApi from '../utils/opsloth_cms_service_api'
import axios from 'axios'
const OSS = require('ali-oss')
const timezone = new Date().getTimezoneOffset()
const client = new OSS({
  // region: 'oss-cn-shanghai',
  cname: true,
  endpoint: timezone == -480 ? 'https://cdn.cms.opsloth.com:443' : "cms-service.oss-accelerate.aliyuncs.com",
  accessKeyId: 'LTAI5tJT7zbHi9sRvdFn6z3g',
  accessKeySecret: 'FcnTyEN8q3u3NsQku60zPg3j4CQWe1',
  bucket: 'cms-service'
})

const uploadImage = (dropedFiles: any, folder: string = '/', type: string = '/') => {
  return new Promise(async (resolve, reject) => {
    let resultArray = []
    let postData = []
    for (let i = 0; i < dropedFiles.length; i++) {
      let dropedFile = dropedFiles[i]
      const result: { url: string } = await client.put(
        (folder + '/' + (new Date().getTime()) + dropedFile.name).replace("//", '/'),
        dropedFile,
        {
          headers: {
            'Content-Disposition': 'inline'
          }
        }
      )
      resultArray.push(result.url)
      postData.push({
        url: result.url,
        folder: folder.lastIndexOf('/') == folder.length - 1 ? folder : folder + '/',
        type: type
      })
    }
    if (type != "job_payment_imgs") {
      const dataModel = new CMSApi('image_metas')
      await dataModel.post(postData)
    }
    resolve(resultArray)
  })
}
const getBase64ImageSize = (base64: string) => {
  if (base64.substring(0, 22) === 'data:image/png;base64,') {
    // base64 是用四个字符来表示3个字节
    // 我们只需要截取base64前32个字符(不计开头那22个字符)便可（24 / 3 * 4）
    // 这里的data包含12个字符，9个字节，除去第1个字节，后面8个字节就是我们想要的宽度和高度
    const data = base64.substring(22 + 20, 22 + 32);
    const base64Characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const nums = [];
    for (const c of data) {
      nums.push(base64Characters.indexOf(c));
    }
    const bytes = [];
    for (let i = 0; i < nums.length; i += 4) {
      bytes.push((nums[i] << 2) + (nums[i + 1] >> 4));
      bytes.push(((nums[i + 1] & 15) << 4) + (nums[i + 2] >> 2));
      bytes.push(((nums[i + 2] & 3) << 6) + nums[i + 3]);
    }
    const width = (bytes[1] << 24) + (bytes[2] << 16) + (bytes[3] << 8) + bytes[4];
    const height = (bytes[5] << 24) + (bytes[6] << 16) + (bytes[7] << 8) + bytes[8];
    return {
      width,
      height,
    };
  } else {
    return {
      width: 0,
      weight: 0
    };
  }
}
const getBase64Image = (imgUrl: string) => {
  return new Promise((resolve, reject) => {
    if (imgUrl && imgUrl != '/') {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.src = imgUrl
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx: any = canvas.getContext('2d');
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL();
        resolve(dataUrl)
      }
    } else {
      resolve('data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7')
    }
  })
}

function getSmallerImgUrl(imgUrl: string, size = 100, quality = 50) {// size需要保持100，不然alicdn不支持
  if (imgUrl && imgUrl.startsWith('https://cms-service.oss-accelerate.aliyuncs.com')){
    imgUrl = imgUrl.replace("https://cms-service.oss-accelerate.aliyuncs.com", "https://cdn.cms.opsloth.com")
  }
  if (imgUrl && (imgUrl.startsWith('https://cms-service.oss-cn-shanghai.aliyuncs.com')
    || imgUrl.startsWith('http://cms-service.oss-cn-shanghai.aliyuncs.com')
      || imgUrl.startsWith('https://cdn.cms.opsloth.com')
      || imgUrl.startsWith('http://cdn.cms.opsloth.com')
      || imgUrl.startsWith('https://cms-service.oss-accelerate.aliyuncs.com'))) {
    return imgUrl + `?x-oss-process=image/resize,w_${size}/quality,q_${quality}/format,webp`
  } else if (imgUrl && imgUrl.indexOf('alicdn.com') >= 0) {
    if (imgUrl.indexOf('ae01.alicdn.com') >= 0){
      return imgUrl + `_${size}x${size}.webp`
    }else{
      return imgUrl + `_${size}x${size}_.webp`
    }
  } else {
    return imgUrl
  }
}

function uploadAMNBUSImageByUrl(url: string) {
  return new Promise(async (resolve, reject) => {
    if (url && url.toString().startsWith("https://amnibus.com/products/detail/")) {
      const res = await axios.get(url)
      if (res.data.indexOf("https://cdn.amnibus.com/upload/save_image") >= 0) {
        // const regex = /<meta property="og:image" content="(.*?)"/
        const regex = /<a href="(.*?)" class="js-smartPhoto">/
        const match = res.data.match(regex);
        const response = await fetch(match[1]);
        const blob = await response.blob();
        const mainImageFile = new File([blob], ".jpg", { type: "mimeType" });
        const mainImageUrl = await uploadImage([mainImageFile], "AMNBUS") as string[]
        resolve(mainImageUrl[0])
      } else {
        resolve(false)
      }
    } else {
      resolve(false)
    }
  })
}

function uploadMATSUMURAImageByUrl(url: string) {
  return new Promise(async (resolve, reject) => {
    if (url && url.toString().startsWith("https://ec-matsumura-s.com/static")) {
        const mainImage = url
        const response = await fetch(mainImage);
        const blob = await response.blob();
        const mainImageFile = new File([blob], ".jpg", { type: "mimeType" });
        const mainImageUrl = await uploadImage([mainImageFile], "MATSUMURA") as string[]
        resolve(mainImageUrl[0])
    } else {
      resolve(false)
    }
  })
}

function wait300ms() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {

    }, 300);
  })
}

export default {
  getBase64ImageSize,
  getBase64Image,
  getSmallerImgUrl,
  uploadImage,
  uploadAMNBUSImageByUrl,
  uploadMATSUMURAImageByUrl
}